<template>
  <div id="contenedor-main-contrato-responsables">
    <tool-bar
      class="my-3"
      v-on:registrarResponsable="mostrarVentanaRegistarResponsable = true"
    />
    <template v-if="getContratoResponsables.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay responsables registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <listado :listadoResponsables="getContratoResponsables" />
    </template>
    <v-dialog v-model="mostrarVentanaRegistarResponsable" width="500">
      <registrar-nuevo-responsable
        :idContrato="this.idContrato"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog
      v-if="esteResponsableContrato"
      v-model="mostrarVentanaEliminarResponsableContrato"
      width="450"
    >
      <eliminar-responsable
        :responsableContratoEliminar="this.esteResponsableContrato"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
// import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import CONTRATO_RESPONSABLES from '@/graphql/querys/administracion/contratos/responsables/contratoResponsables.gql';
import RegistrarNuevoResponsable from '@/components/administracion/contratos/contrato/responsable/Nuevo.vue';
import EliminarResponsable from '@/components/administracion/contratos/contrato/responsable/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoResponsables',
  components: {
    ToolBar,
    Listado,
    RegistrarNuevoResponsable,
    EliminarResponsable,
  },
  apollo: {
    contratoResponsables: {
      query: CONTRATO_RESPONSABLES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  // apollo: {
  //   contratos: {
  //     query: CONTRATOS,
  //   },
  // },
  data() {
    return {
      mostrarVentanaRegistarResponsable: false,
      mostrarVentanaEliminarResponsableContrato: false,
      esteResponsableContrato: null,
      idContrato: this.$route.params.idContrato,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaRegistarResponsable = false;
      this.mostrarVentanaEliminarResponsableContrato = false;
      this.esteResponsableContrato = null;
    },
  },
  computed: {
    getContratoResponsables() {
      if (!this.contratoResponsables) return [];
      return this.contratoResponsables;
    },
    // contrato() {
    //   if (!this.contratos) return {};
    //   return this.contratos.find((elem) => elem.id === this.$route.params.idContrato);
    // },
  },
  mounted() {
    eventBus.$on('borrar-responsable-contrato', (responsableContrato) => {
      this.esteResponsableContrato = responsableContrato;
      this.mostrarVentanaEliminarResponsableContrato = true;
    });
  },
};
</script>

<style lang="scss">
</style>
